import { useEffect } from "react";

const useSelectionStateToForm = (handleFormChange, field, selectionState) => {
    useEffect(() => {
        handleFormChange(selectionState.rows, { name: field, ignoreDirty: !selectionState.isDirty })
    }, [selectionState, handleFormChange, field]);
}

export default useSelectionStateToForm;